import { useMemo } from 'react';

import Dropzone from '@adsk/alloy-react-dropzone';

import { useTranslation } from '../i18n';

type DropzoneTitleOptions = {
  customDropzoneTitle?: string;
  size: string;
  enableUploadOnPaste?: boolean;
};

const DROPZONE_TITLE_KEYS = {
  small: {
    withPaste: 'DROPZONE_TEXT_OR_PASTE_OR',
    withoutPaste: 'DROPZONE_TEXT_OR',
  },
  default: {
    withPaste: 'DROPZONE_TEXT_OR_PASTE',
    withoutPaste: 'DROPZONE_TEXT',
  },
} as const;

export const useDropzoneTitle = ({
  customDropzoneTitle,
  size,
  enableUploadOnPaste,
}: DropzoneTitleOptions): string => {
  const { t } = useTranslation();

  return useMemo(() => {
    if (customDropzoneTitle) return customDropzoneTitle;

    const sizeKey = size === Dropzone.SIZES.SMALL ? 'small' : 'default';
    const pasteKey = enableUploadOnPaste ? 'withPaste' : 'withoutPaste';

    return t(DROPZONE_TITLE_KEYS[sizeKey][pasteKey]);
  }, [customDropzoneTitle, size, enableUploadOnPaste, t]);
};
